import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../../Shared/REST';
import '../../assets/custom.css';
import Helpers from "../../Shared/Helpers";
import {BUCKET_URL, MAIN} from "../../Shared/Consts";
import queryString from 'query-string';
import {updateStudent} from "../../TeachersComponent/actions";
import ico_correct from '../../assets/images/correct.png';
import ico_wrong from '../../assets/images/wrong.png';
import FooterComponent from "../../Shared/Footer";
import HeaderComponent from "../../Shared/Header";
import connect from "react-redux/es/connect/connect";

import logo_copyright from '../../assets/images/app-copyright.png';
import DialogBox from "../../Shared/DialogBox";
import DeleteDialogBox from "../../Shared/DeleteDialogBox";
import logo_kidsign from "../../assets/images/app-kidsignsay.png";
import DropDownNotifications from "../../Shared/DropDownNotifications";
import ReportBugForm from "../../ModalFormComponents/ReportBugForm";
import closeRedX from "../../assets/images/modal_x.png";
import TRACKING from "../../Shared/DataTrackingPoints";
import {Modal} from "react-bootstrap";
import warningIcon from "../../assets/images/ico-warning.png";

class CRGrading extends Component {

    constructor(props) {
        super(props);
        this.state = {
            testId: null,
            paused: true,
            bestScores: null,
            rejectedReason: '',
            recording: false,
            imageSrc: "",
            videoSrc: "",
            currentWord: "",
            currentIndex: -1,
            crVideo: null,
            studentJoined: false,
            crWords: [],
            crSession: null,
            gradeStart:null,
            modalDialog:false,
            responseContent:'',
            modalDialogDelete: false,
            modalDialogNote: false,
            noteContent:'',
            handleNext: false,
            taskID:null,
            showPlayInstructorHint:false,
            showPlayVideoHint: false,
            showKeywordHint: false,
            showDeleteHint: false,
            showSaveHint: false,
            play:false,
            play1:false,
            sessionData: {
                testId: 0,
                gradeSequence: "",
                gradingTime: 0,
                numberCorrect: 0,
                numberIncorrect: 0
            },
            analytics: {
                type: null,
                metadata: null,
            }
        };

        this.startGrading = this.startGrading.bind(this);
        this.gradeToggle = this.gradeToggle.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.submitCRSessionGrade = this.submitCRSessionGrade.bind(this);
        this.updateCRBestScore = this.updateCRBestScore.bind(this);
        this.setupGradingData = this.setupGradingData.bind(this);
        this.deleteScore = this.deleteScore.bind(this);
        this.handleTakeANote = this.handleTakeANote.bind(this);
        this.saveNote = this.saveNote.bind(this);
        this.deleteNote = this.deleteNote.bind(this);
        this.handleNoteClose = this.handleNoteClose.bind(this);
        this.handleNoteContentChange = this.handleNoteContentChange.bind(this);
        this.handleStudentClick = this.handleStudentClick.bind(this);
        this.handleNextTask = this.handleNextTask.bind(this);
        this.getTarget = this.getTarget.bind(this);
        this.getTarget1 = this.getTarget1.bind(this);
        this.getTarget2 = this.getTarget2.bind(this);
        this.getTarget3 = this.getTarget3.bind(this);
        this.getTarget4 = this.getTarget4.bind(this);
        this.handleShowHints = this.handleShowHints.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
        this.handlePlay1 = this.handlePlay1.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);

    }

    async componentDidMount() {
        Helpers.authorize(this);
        const parsed = queryString.parse(this.props.location.search);
        await this.setState({
            testId: parsed.testId,
            gradeStart: Date.now(),
            analytics:{
                type: TRACKING.CR_SCORE_VIEW,
                metadata:{testId:parsed.testId}
            }
        });
        this.startGrading(parsed.testId);
        REST.getStudentNotifications().then(res => {
            for(let i = 0; i < res.body.length; i++){
                for(let j=0; j<res.body[i].apps.copyRightScores.length; j++){
                    let copyRightScores = res.body[i].apps.copyRightScores[j];
                    if (copyRightScores && copyRightScores.userId === this.props.lastStudent.user.id && copyRightScores.id != parsed.testId) {
                        this.setState({
                            handleNext: true,
                            taskID: copyRightScores.id
                        });
                    }
                }
            }
        });
        this.handleAnalytics();
    };

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleNextTask(){
        window.location.href = '/teacher/apps/cr-grading?testId=' + this.state.taskID;
    }

    async updateCRBestScore() {
        if (this.state.bestScores.crLevel === this.state.crSession.startLevel) {
            let newProgress = this.state.bestScores.crScore;
            let newLevel = await this.state.bestScores.crLevel;

            let goalScore = 0;
            if(newLevel == 1){
                goalScore = 1;
            } else if (newLevel == 2){
                goalScore = 2;
            } else if (newLevel == 3){
                goalScore = 3;
            } else if (newLevel == 4){
                goalScore = 4;
            } else if (newLevel == 5){
                goalScore = 5;
            } else if (newLevel == 6) {
                goalScore = 5;
            }

            if (this.state.sessionData.numberCorrect >= goalScore) {
                await newProgress++;
            } else {
                await newProgress--;
            }

            if (newProgress > 3 && newLevel <= 6) {
                await newLevel++;
                newProgress = 1;
            } else if (newProgress === 0) {
                 newProgress = 1;
            }

            await this.setState({
                bestScores: {
                    ...this.state.bestScores,
                    crLevel: newLevel,
                    crScore: newProgress
                }
            });
            await REST.updateCRBestScore(this.state.bestScores);
        }
    }

    submitCRSessionGrade = async () => {
        let grades = this.state.crSession.gradeSequence.split(",");
        let correct = 0;
        let incorrect = 0;
        for(let grade of grades){
            if(grade==="1"){
                correct++;
            }else{
                incorrect++
            }
        }
        await this.setState({
            sessionData: {
                testId: this.state.testId,
                gradeSequence: this.state.crSession.gradeSequence,
                gradingTime: Math.ceil((Date.now() - this.state.gradeStart)/1000),
                numberCorrect: correct,
                numberIncorrect: incorrect
            }
        });
        console.log("Submitting session data: ", this.state.sessionData);
        await REST.gradeCRSession(this.state.sessionData).then(async (res) => {
            await this.updateCRBestScore();
            this.setState({
                modalDialog: true,
                responseContent:'Score task saved.',
                analytics: {
                    type: TRACKING.CR_SCORE_SAVE,
                    metadata: {testId: this.state.testId}
                }
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        this.handleAnalytics();
    };

    startGrading = (testId) => {
        REST.getCRSession(testId).then(async (res) => {
            let crSession = res.body;
            if (crSession) {
                console.log("CR SESSION GET", crSession);
                let bestScores = await REST.getStudentBestScores(crSession.userId);
                await this.setState({
                    crSession: crSession,
                    bestScores: bestScores.body,
                    noteContent: crSession.note,
                    crVideo: crSession.cr_video,
                    videoSrc: BUCKET_URL + crSession.AV_FileName
                });
                this.video.src = BUCKET_URL + crSession.AV_FileName;
                this.crVideo.src = crSession.cr_video.url;
                this.setupGradingData();
            } else {
                console.log("ERROR");
                this.setState({
                    modalDialog: true,
                    responseContent:'An Invalid Assessment ID has been provided.'

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }

        }).catch(error => {
            console.log("ERROR", error)
            this.setState({
                modalDialog: true,
                responseContent:'An Invalid Assessment ID has been provided.'

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    };

    setupGradingData() {
        if (this.state.crSession.gradeSequence == null || this.state.gradeSequence === "") {
            let grades = [];
            let words = this.state.crVideo.aslSigns.split(",");
            for (let i = 0; i < words.length; i++) {
                grades[i] = "0";
            }
            this.setState({
                crSession: {
                    ...this.state.crSession,
                    gradeSequence: grades.join(",")
                }
            });
        }
    }

    handleReset(){
        let gradeSequence = this.state.crSession.gradeSequence;
        let grades = gradeSequence.split(",");
        for (let i=0; i<gradeSequence.length; i++) {
            grades[i] = "0";
        }
        this.setState({
            crSession: {
                ...this.state.crSession,
                gradeSequence: grades.join(",")
            }
        });

    }

    gradeToggle(index, currentGrade) {
        currentGrade = parseInt(currentGrade);
        let gradeSequence = this.state.crSession.gradeSequence;
        let grades = gradeSequence.split(",");
        if (currentGrade === 0) {
            currentGrade = 1;
        } else {
            currentGrade = 0;
        }
        grades[index] = currentGrade.toString();
        this.setState({
            crSession: {
                ...this.state.crSession,
                gradeSequence: grades.join(",")
            }
        });
    }

    async deleteScore(){
            await this.setState({
                analytics: {
                    type: TRACKING.CR_SCORE_DELETE,
                    metadata: {testId: this.state.testId},
                }
            });
            await REST.deleteCopyRightScore(this.state.testId).then(res => {
                this.handleAnalytics();
                this.props.history.goBack();
            });
    }

    deleteScoreConfirm = (confirm) =>{
        if(confirm) {
            this.deleteScore();
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleTakeANote(){
        console.log("take a note");
        this.setState({
            modalDialogNote:true,
        });
    }

    handleNoteContentChange(event) {
        this.setState({ noteContent: event.target.value });
        event.preventDefault();
    }

    saveNote(){
        REST.updateCopyRightNote({testId:this.state.testId, note:this.state.noteContent});
        this.setState({
            modalDialogNote:false,
        });
    }

    deleteNote(){
        this.setState({noteContent:''});
        REST.updateCopyRightNote({testId:this.state.testId, note:''});
    }

    handleNoteClose(){
        this.setState({
            modalDialogNote:false,
        });
    }

    handleStudentClick = (student, classId) => {
        this.props.updateStudent(student);
        this.props.history.push('/teacher/student');
    };

    getTarget(){
        this.setState({
            showPlayInstructorHint: false
        });
    }
    getTarget1() {
        this.setState({
            showPlayVideoHint: false
        });
    }
    getTarget2() {
        this.setState({
            showKeywordHint: false
        });
    }
    getTarget3() {
        this.setState({
            showDeleteHint: false
        });
    }
    getTarget4() {
        this.setState({
            showSaveHint: false
        });
    }
    handleShowHints(){
        this.setState({
            showPlayInstructorHint:true,
            showPlayVideoHint: true,
            showKeywordHint: true,
            showDeleteHint: true,
            showSaveHint: true,
        })
    }
    async handlePlay(){
        if(this.state.play){
            this.video.pause();
            this.setState({play:false});
        }
        else{
            this.video.play();
            await this.setState({
                play:true,
                analytics: {
                    type: TRACKING.CR_SCORE_PLAY,
                    metadata: {testId: this.state.testId},
                }
            });
            this.handleAnalytics();
        }
    }
    async handlePlay1(){
        if(this.state.play1){
            this.crVideo.pause();
            this.setState({play1:false});
        }
        else{
            this.crVideo.play();
            this.setState({play1:true});
        }
    }

    async handleSurveyBack(){
    }

    render() {

        let wordThumbnails = null;
        if (this.state.crVideo && this.state.crVideo.aslSigns && this.state.crSession.gradeSequence) {
            wordThumbnails = this.state.crVideo.aslSigns.split(",").map((crWord, index) => {

                let currentGrade = this.state.crSession.gradeSequence.split(",")[index];
                let gradeSrc = "btn-info2";
                if (crWord.toString().startsWith("IX")) {
                    gradeSrc = "btn-warning";
                }
                if (currentGrade === "1") {
                    gradeSrc = "btn-success";
                }
                // else if (currentGrade === "2") {
                //     gradeSrc = "btn-danger"
                // }

                return (<button
                    key={index}
                    onClick={() => this.gradeToggle(index, currentGrade)}
                    style={{margin:"5px"}}
                    className={"btn " + gradeSrc}
                    type="button">{crWord}</button>)
            });
        }
        return (
            <div>
                {/*<HeaderComponent notifications studentClick={this.handleStudentClick} gradingApps imageSrc={logo_copyright} sName={this.props.lastStudent} appName={'Copyright Scoring'}  {...this.props}/>*/}
                <div className="section bgGrey" style={{paddingTop:10}}>
                    <div className="container">
                        <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                        <DialogBox surveyModal role={'teacher'} app={'CRGrading'} userId={this.props.user.id} active={true} surveyBack={this.handleSurveyBack}/>
                        <DeleteDialogBox
                            confirmDelete={this.deleteScoreConfirm}
                            modalOpen={this.state.modalDialogDelete}
                            sectionContent={this.state.responseContent}
                            closeClick={(active)=>{this.setState({modalDialog: active});}} />
                        <Modal id="dialogBox" show={this.state.modalDialogNote}>
                            <div className="modal-content">
                                <div className={"row modal-body"}>
                                    {/*<span style={{cursor:"pointer"}} onClick={this.closeModal}><img style={{width:50,marginTop:25,float:'right'}} src={closeModalIcon} /></span>*/}
                                    <div className="section">
                                        <h1 style={{paddingTop:0, marginTop:-10,marginBottom:15}}>Make a Note</h1>
                                        <textarea
                                            style={{width:500}}
                                            onChange={this.handleNoteContentChange}
                                            value={this.state.noteContent}
                                            placeholder={"Please enter your note here"}
                                        ></textarea>
                                    </div>
                                    <div className="section" style={{marginTop:-40}}>
                                        <div className={"col-md-4"}>
                                        </div>
                                        <div className={"col-md-4"}>
                                            <a style={{float:'left'}} onClick={this.deleteNote} className="handBtn">
                                                <span>Delete</span>
                                            </a>
                                        </div>
                                        <div className={"col-md-4"}>
                                            <a style={{float:'left'}} onClick={this.saveNote} className="handBtn">
                                                <span>Close</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="col-lg-12 noPadding mobileCenter">
                                    <div className="col-sm-4"><h1><img src={logo_copyright} alt={"Copy Right"} style={{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}/> {this.props.lastStudent.user.firstname} {this.props.lastStudent.user.lastname}</h1></div>
                                    <div className="col-sm-8 tr"><span className="descp"></span>
                                        <div className={"navbar"}> <ReportBugForm {...this.props} /><DropDownNotifications studentClick={this.handleStudentClick} {...this.props} /><a onClick={this.handleShowHints} className="handBtn"><span>Show Hints</span></a></div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <hr/>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="row">
                            {/*<div className="col-lg-12">*/}
                                {/*<div className="col-lg-12 noPadding mobileCenter">*/}
                                    {/*<div className="col-sm-4"><h1>CopyRight Scoring</h1></div>*/}
                                    {/*<div className="col-sm-8 tr"><span className="descp"></span></div>*/}
                                    {/*<div className="clearfix"></div>*/}
                                    {/*<hr/>*/}
                                {/*</div>*/}
                                {/*<div className="clearfix"></div>*/}
                            {/*</div>*/}
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="col-lg-12 solidBorder">
                                    <div className="col-lg-12">
                                        <div className="col-lg-6 col-xs-6 col-md-6">
                                            <div className={"wrapper"}>
                                            <video id={"copyrightVidPlayback"} onClick={this.handlePlay} controls={true} playsinline={true} ref={video => {
                                                this.video = video
                                            }} width="100%" height="100%"/>
                                                <div className={!this.state.play ? "playpause" : ""} style={{cursor:'pointer'}} onClick={this.handlePlay}></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-xs-6 col-md-6 hasVideo">
                                            <div className={"wrapper"}>
                                            <video
                                                id={"copyrightInstruction"}
                                                onClick={this.handlePlay1}
                                                ref={crVideo => this.crVideo = crVideo}
                                                src={this.state.crVideoSrc !== "" ? this.state.crVideoSrc : undefined}
                                                playsinline={true}
                                                autoPlay={false}
                                                controls={true}
                                                width="100%" height="100%"
                                            />
                                                <div className={!this.state.play1 ? "playpause" : ""} style={{cursor:'pointer'}} onClick={this.handlePlay1}></div>
                                            </div>
                                            <div className="row bgGrey">
                                                <p style={{fontFamily:'Open Sans',fontSize:15}}>{this.state.crVideo ? this.state.crVideo.englishSentence : ""}</p>
                                                <div style={{position:'relative', display:'inline-block'}}>

                                                <div hidden={!this.state.showKeywordHint} className={"popoverCustom"}>
                                                    <div className={"col-md-12 noPaddingLR"} style={{position:'relative'}}>
                                                        <div style={{display:"inline-block", float:'right'}}>
                                                            <img src={closeRedX} onClick={this.getTarget2} style={{width:35,paddingRight:5,cursor:'pointer'}} />
                                                        </div>
                                                        <div style={{display:"inline-block"}}>
                                                            <div style={{fontSize:'20px',fontFamily:'mainfont, sans-serif', letterSpacing:'1px'}}>Hint:</div>
                                                        </div>
                                                    </div>
                                                    Click a word to score
                                                </div>
                                                    <div hidden={!this.state.showKeywordHint} className={"arrowPointer"}></div>
                                                    {wordThumbnails}
                                                </div>
                                            </div>

                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 paddingTop">
                                <div className="divBottomRelative tr">
                                    <a onClick={async () => {
                                        await this.setState({
                                            analytics: {
                                                type: TRACKING.CR_SCORE_EXIT,
                                                metadata: {testId: this.state.testId},
                                            }
                                        }); this.handleAnalytics(); this.props.history.push('../student')}}
                                       className="handBtn fl"><span>Exit</span></a>
                                    <a onClick={this.handleNextTask} className="handBtn" style={{ display: this.state.handleNext ? 'inline-block': 'none'}}><span>Next Task</span></a>
                                    <a onClick={this.handleTakeANote} className="handBtn" ><span>Make a Note</span></a>
                                    <a onClick={this.submitCRSessionGrade} className="handBtn"><span>Save</span></a>
                                    <a onClick={this.handleReset}
                                       className="handBtn"><span>Reset</span></a>
                                    <div style={{position:'relative', display:'inline-block',textAlign:'left'}}>

                                        <div hidden={!this.state.showDeleteHint} className={"popoverCustom"}>
                                            <div className={"col-md-12 noPaddingLR"} style={{position:'relative'}}>
                                                <div style={{display:"inline-block",float:'right'}}>
                                                    <img src={closeRedX} onClick={this.getTarget3} style={{width:35,paddingRight:5,cursor:'pointer'}} />
                                                </div>
                                                <div style={{display:"inline-block"}}>
                                                    <div style={{fontSize:'20px',fontFamily:'mainfont, sans-serif', letterSpacing:'1px'}}>Hint:</div>
                                                </div>
                                            </div>
                                            Delete to remove this video from scoring
                                        </div>
                                        <div hidden={!this.state.showDeleteHint} className={"arrowPointer"}></div>
                                        <a onClick={() => {this.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS Task?'})}} className="handBtn"><span>Delete</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );

    }
}
const actionToProps = dispatch => {
    return {
        updateStudent: async(student) => await dispatch(updateStudent(student))
    };
};
const mapStateToProps = state => ({
    lastStudent: state.teacherReducer.student,
});
export default connect(mapStateToProps,actionToProps)(withRouter(CRGrading));


// WEBPACK FOOTER //
// ./src/TeachersComponent/CRGrading/CRGrading.js